import { FormModel } from 'components/Form';
import { addonsType, discountType } from 'utils/constants/data';
import { Validators } from 'utils/validators';

export const AddEditOtherItemsForm = (
  strings: any,
  isPerGuest: boolean,
  taxGroups: any,
  discountDisabled: boolean,
  addOnCategories: any,
  isAng: boolean,
  isOperaIntegration: boolean = false,
): FormModel[] => {
  const form: FormModel[] = [
    {
      label: strings.booking_details_actual_revenue_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: strings.booking_details_actual_revenue_category,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'category',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: addOnCategories,
    },
    {
      label: strings.addOnHsnCode,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'hsnCode',
      validators: isOperaIntegration
        ? [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }]
        : [{ check: Validators.validateString, max: 100 }],
      responsive: { xs: 12 },
      required: isOperaIntegration,
      infoText: strings.hsnCodeInfo ?? null,
    },
    {
      label: strings.booking_details_actual_revenue_type,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'type',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      options: addonsType(strings),
      responsive: { xs: 12 },
    },
  ];

  isPerGuest &&
    form.push({
      label: strings.booking_details_actual_revenue_quantity,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'quantity',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt }],
      responsive: { xs: 12 },
      required: true,
    });

  form.push({
    label: strings.booking_details_actual_revenue_price,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'number',
    variant: 'outlined',
    placeholder: '',
    field: 'price',
    validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
    responsive: { xs: 12 },
    required: true,
  });
  !isAng &&
    form.push({
      label: strings.taxGroup,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: strings.taxGroup,
      field: 'taxGroupId',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      isMulti: false,
      options: taxGroups,
    });
  form.push(
    {
      label: strings.discountType,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'discountType',
      validators: [],
      responsive: { xs: 6 },
      required: false,
      options: discountType(strings),
    },
    {
      label: strings.discount,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      placeholder: '',
      field: 'discount',
      validators: [{ check: Validators.validateInt }],
      required: false,
      responsive: { xs: 6 },
      disabled: discountDisabled,
    },
  );
  return form;
};
